/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Favorites_DescriptionInputs */



/**
* | output |
* | --- |
* | "Link spaces and files to provide context for all chats in this project." |
*
* @param {Project_Favorites_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_favorites_description = /** @type {((inputs?: Project_Favorites_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Favorites_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verknüpfe Spaces und Dateien, um Kontext für alle Chats in diesem Projekt bereitzustellen.")
	return /** @type {LocalizedString} */ ("Link spaces and files to provide context for all chats in this project.")
});